import React from 'react';

const SingleLoader = props => {
  return (
    <div
      style={{
        width: '327px',
        height: '27px',
        borderRadius: '4px',
        backgroundColor: '#f3f3f3',
      }}
      {...props}
    />
  );
};

export default SingleLoader;
